<template>
  <v-container fluid id="crm">
    <template v-if="!historyCustomAudiencePage">
      <v-layout wrap>
        <v-flex xs12 sm4>
          <h2>{{ $t('All Users') }}</h2>
        </v-flex>
        <v-flex xs12 sm8 class="text-xs-right">
          <template v-if="loading">
            <v-btn outline loading color="grey"></v-btn>
            <v-btn outline loading color="grey"></v-btn>
          </template>
          <template v-else>
            <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
              <v-btn color="grey" outline>
                <i class="fas fa-file-import"></i>
                &nbsp;
                {{ $t('Import') }}&nbsp;
                <v-premium-lock
                  :inline="true"
                  text="Import previous users installing chatbots into the system easily. Upgrade to Premium! Starting at 500 baht/month."
                ></v-premium-lock>
              </v-btn>
              <v-btn color="grey" outline>
                <i class="fas fa-file-export"></i>
                &nbsp;
                {{ $t('export') }}&nbsp;
                <v-premium-lock
                  :inline="true"
                  text="Bring the data to excel for analysis. Upgrade to Premium onwards, starting at 500 baht/month."
                ></v-premium-lock>
              </v-btn>
              <template>
                <v-btn
                  style="margin-right: 6px; border-radius: 20px 0px 0px 0px !important;"
                  color="grey"
                  :disabled="loadCount || selectedBot.facebook_ad_account_id === null"
                  :outline="!loadCount && selectedBot.facebook_ad_account_id !== null"
                  @click="createCustomAudienceDialog = true"
                >
                  <i class="fab fa-facebook-square"></i>
                  &nbsp;
                  {{ $t('Create Custom Audience') }}
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="grey"
                      v-on="on"
                      style="display: inline-block; border-radius: 0; margin-left: -10px; border-radius: 0px 20px 20px 0px !important;"
                      outline
                      icon
                    >
                      <v-premium-lock
                        style="margin-right: 10px"
                        text="upgrade_premium_onwards"
                      ></v-premium-lock>
                    </v-btn>
                  </template>
                </v-menu>
              </template>
            </template>
            <template v-else>
              <template v-if="filter.app.value == 'facebook'">
                <v-btn
                  style="margin-right: 6px; border-radius: 20px 0px 0px 0px !important;"
                  color="grey"
                  :disabled="loadCount || selectedBot.facebook_ad_account_id === null"
                  :outline="!loadCount && selectedBot.facebook_ad_account_id !== null"
                  @click="createCustomAudienceDialog = true"
                >
                  <i class="fab fa-facebook-square"></i>
                  &nbsp;
                  {{ $t('Create Custom Audience') }}
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="grey"
                      v-on="on"
                      style="display: inline-block; border-radius: 0; margin-left: -10px; border-radius: 0px 20px 20px 0px !important;"
                      outline
                      icon
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="historyCustomAudiencePage = true">
                      <v-list-tile-title>{{
                        $t('View Custom Audiences History')
                      }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
              <template v-if="loading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </template>
              <template v-else>
                <template v-if="computedImportDelay > 0">
                  <v-btn color="grey" outline>
                    {{ $t('loading_import_user') }}
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    color="grey"
                    outline
                    @click="importCustomer"
                    v-if="!$store.state.hideImportOldUser.includes(selectedBot.pageid)"
                  >
                    <i class="fas fa-file-import"></i>
                    &nbsp;
                    {{ $t('Import') }}
                  </v-btn>
                </template>
              </template>
              <v-btn
                style="margin-right: 6px!important; border-radius: 20px 0px 0px 0px !important;"
                color="grey"
                outline
                @click="onExportCustomer('info')"
              >
                <i class="fas fa-file-export" />
                &nbsp;
                {{ $t('export') }}
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    v-on="on"
                    style="display: inline-block; border-radius: 0; margin-left: -10px; border-radius: 0px 20px 20px 0px !important;"
                    outline
                    icon
                  >
                    <v-icon>arrow_drop_down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="onExportCustomer('dataSummary')">
                    <v-list-tile-title>{{ $t('Export all data summary') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
          </template>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm8 class="mt-2">
          <template v-if="filter && filter.app && !showAdvance">
            <v-btn
              v-for="item in createFilterButtons()"
              :key="item.value"
              small
              depressed
              :outline="filter.app.value !== item.value"
              :color="filter.app.value === item.value ? 'primary' : 'grey'"
              @click="onFilterButtonClick(item)"
              class="ma-0 mr-1 mb-1"
            >
              <i :class="item.icon" class="mr-1"></i>
              {{ item.label }}
            </v-btn>
          </template>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-right">
          <v-btn dark depressed color="primary" @click="openAdvanceSearch()">
            <v-icon>search</v-icon>
            &nbsp;
            {{ $t('advanced search') }}&nbsp;
            <i class="fas fa-angle-down" v-if="!showAdvance"></i>
            <i class="fas fa-angle-up" v-else></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <div
        v-if="showAdvance"
        class="mb-4"
        style="border: 1px solid #eee; border-radius: 10px; position: relative"
      >
        <template>
          <v-premium-plan-popup
            :showAll="false"
            marginTop="65"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            style="border-radius: 10px"
            text="Want to find specific customer information? Upgrade from Premium onwards, starting at 500 baht/month Upgrade now!"
          ></v-premium-plan-popup>
          <filter-customer :total_user="total_user" v-model="filter" ref="filterCustomer">
            <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed @click="onSearch" color="primary">
              <i class="fas fa-search mr-1"></i>
              {{ $t('Search') }}
            </v-btn>

            <div slot="append" slot-scope="{ filter }" v-if="selectedBot.theme == 'hafele'">
              <v-divider class="mt-2"></v-divider>
              <v-layout wrap>
                <v-flex xs12 sm4 class="form-control pa-1">
                  <label for class="caption">{{ $t('Emp ID') }}</label>
                  <input
                    type="text"
                    :placeholder="$t('Emp ID')"
                    v-model="filter.emp_id"
                    class="form-control"
                    maxlength="255"
                  />
                </v-flex>
                <v-flex xs12 sm4 class="form-control pa-1">
                  <label for class="caption">{{ $t('Emp Name') }}</label>
                  <input
                    type="text"
                    :placeholder="$t('Emp First Name')"
                    v-model="filter.emp_first_name"
                    class="form-control"
                    maxlength="255"
                  />
                </v-flex>
                <v-flex xs12 sm4 class="form-control pa-1">
                  <label for class="caption">{{ $t('Emp Name') }}</label>
                  <input
                    type="text"
                    :placeholder="$t('Emp Last Name')"
                    v-model="filter.emp_last_name"
                    class="form-control"
                    maxlength="255"
                  />
                </v-flex>
              </v-layout>
            </div>
          </filter-customer>
        </template>
      </div>
      <v-layout class="mt-4">
        <v-flex>
          <custom-paginate
            v-model="pageNumber"
            :hasNext="hasNext"
            :hasPrev="hasPrev"
            :pagelength="pagelength"
            @onChangePage="onChangePage"
            :loading="loading"
          ></custom-paginate>
          <!-- <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination> -->
        </v-flex>
        <v-flex class="ma-2 text-xs-right" shrink>
          <span class="caption mr-2">{{ $t('Total') }}</span>
          <template v-if="loadCount">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </template>
          <template v-else>
            <template v-if="total_user === false">
              <v-btn
                fab
                outline
                small
                color="primary"
                :loading="loading"
                v-if="$store.getters.getPackage != 'premium'"
                v-tooltip.top="'Unlock to PREMIUM plan'"
              >
                <v-icon>lock</v-icon>
              </v-btn>
              <v-btn
                v-else
                outline
                fab
                small
                color="primary"
                :loading="loadCount"
                @click="loadCountData"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
                total_user | numberFormat
              }}</span>
            </template>
          </template>
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="loading"
        :headers="filteredHeader"
        :items="users"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
        hide-actions
      >
        <template slot="headerCell" slot-scope="props">
          <template v-if="props.header.value === 'event_data' && !hasAdvanced">
            {{ props.header.text }}
            <v-premium-lock2
              type="advanced"
              text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
            ></v-premium-lock2>
          </template>
          <template v-else>
            {{ props.header.text }}
          </template>
        </template>
        <template v-slot:items="props">
          <customer-item v-model="props.item"></customer-item>
        </template>

        <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
      </v-data-table>

      <div class="mt-4">
        <custom-paginate
          v-model="pageNumber"
          :hasNext="hasNext"
          :hasPrev="hasPrev"
          :pagelength="pagelength"
          @onChangePage="onChangePage"
          :loading="loading"
        ></custom-paginate>
        <!-- <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination> -->
      </div>

      <v-dialog v-model="showExport" persistent max-width="800" scrollable>
        <v-card>
          <div class="text-xs-right">
            <v-btn fab flat small @click="showExport = false"><v-icon>close</v-icon></v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text style="max-height: 600px">
            <v-layout wrap>
              <v-flex xs6 sm4 md3 :key="`expor_all`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large> folder_shared </v-icon>
                  <div class="caption">
                    All
                  </div>
                  <v-btn small color="primary" depressed @click="exportAlltype">Download</v-btn>
                </div>
              </v-flex>
              <template v-for="page in exportpagecount">
                <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                  <div class="z-border-red text-xs-center py-3">
                    <v-icon x-large> folder_shared </v-icon>
                    <div class="caption">
                      {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                      <template v-if="page == exportpagecount">
                        {{ total_user | numberFormat }}
                      </template>
                      <template v-else>
                        {{ (page * exportlimit) | numberFormat }}
                      </template>
                    </div>
                    <v-btn
                      small
                      color="primary"
                      depressed
                      @click="
                        exportType === 'info'
                          ? exportCustomer((page - 1) * exportlimit)
                          : exportDataSummary((page - 1) * exportlimit)
                      "
                      >download</v-btn
                    >
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="createCustomAudienceDialog" max-width="1000">
        <v-card>
          <div class="text-xs-right">
            <v-btn flat small fab @click="createCustomAudienceDialog = false">
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div class="intent-item " style="padding: 10px 15px 0px;">
              <form>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has(`customAudienceName`) }"
                    >
                      <h3 class="mb-2">{{ $t('Custom Audience Name') }}</h3>
                      <input
                        :placeholder="$t('Please enter custom audience name')"
                        :data-vv-as="$t('Custom Audience Name')"
                        v-model="customAudienceName"
                        :name="`customAudienceName`"
                        class="form-control mr-3"
                        type="text"
                      />
                      <span class="text-error" v-if="errors.has(`customAudienceName`)">{{
                        errors.first(`customAudienceName`)
                      }}</span>
                    </div>
                    <p class="mt-2">
                      {{
                        $t(
                          'for_custom_audience_creation_customer_lists_should_be_more_than_1000_users_If_your_customer_lists_are_less_than_1000_users_recommended_to_set_up_lookalike_on_facebook_ad_manager_for_the_coverage_in_your_audience_settings'
                        )
                      }}
                    </p>
                    <p>
                      {{
                        $t(
                          'to_create_a_custom_audience_your_Facebook_Ads_Account_is_required_for_ads_account_connection_if_you_do_not_have_facebook_business_ads_account_please_check_the_detail_and_how_to_apply'
                        )
                      }}
                      <a
                        href="https://www.facebook.com/business/help/910137316041095?id=420299598837059"
                        target="blank"
                      >
                        {{ $t('here') }}</a
                      >
                    </p>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-btn
                    outline
                    color="grey"
                    :loading="loading"
                    @click="createCustomAudienceDialog = false"
                    >{{ $t('cancel') }}</v-btn
                  >
                  <v-btn
                    depressed
                    color="primary"
                    :loading="loading"
                    @click="createCustomAudience"
                    >{{ $t('Save') }}</v-btn
                  >
                </div>
              </form>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <v-btn flat small color="primary" @click="historyCustomAudiencePage = false">
        <i class="fas fa-angle-left mr-2"></i> {{ $t('Back') }}
      </v-btn>
      <HistoryAudience @Back="historyCustomAudiencePage = false" />
    </template>
    <v-dialog style="z-index: 210" v-model="loadingItem" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            color="#FFFFFF"
            style="border-radius: 5px;"
            class="text-xs-center"
            v-model="loadingItemValue"
            height="19"
          >
            <strong style="font-size: 14px; color: #FFF;">{{ loadingItemValue }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import User from './User.js'
import CustomPaginate from '@/components/elements/CustomPaginate'
import HistoryAudience from '@/components/view/customAudience/HistoryAudience.vue'
import { mapGetters } from 'vuex'
export default {
  mixins: [User],
  components: {
    CustomPaginate,
    HistoryAudience
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    createFilterButtons() {
      const vm = this
      const packages = vm.selectedBot.packages
      const connect_platform = []
      if (packages.includes('facebook')) {
        connect_platform.push({
          label: vm.$t('Facebook'),
          value: 'facebook',
          icon: 'fab fa-facebook-square'
        })
      }
      if (packages.includes('line')) {
        connect_platform.push({
          label: vm.$t('Line'),
          value: 'line',
          icon: 'fab fa-line'
        })
      }
      if (packages.includes('instagram')) {
        connect_platform.push({
          label: vm.$t('Instagram'),
          value: 'instagram',
          icon: 'fab fa-instagram'
        })
      }
      if (packages.includes('whatsapp')) {
        connect_platform.push({
          label: vm.$t('WhatsApp'),
          value: 'whatsapp',
          icon: 'fab fa-whatsapp'
        })
      }
      if (packages.includes('google')) {
        connect_platform.push({
          label: vm.$t('Google'),
          value: 'google',
          icon: 'fab fa-google'
        })
      }
      return connect_platform
    },
    onFilterButtonClick(item) {
      const vm = this
      vm.filter.app = item
      vm.onSearch()
    },
    openAdvanceSearch() {
      if (this.showAdvance) {
        if (this.previousFilterApp) {
          this.filter.app = this.previousFilterApp
        }
      } else {
        this.previousFilterApp = this.filter.app
      }

      this.showAdvance = !this.showAdvance
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/analytics/Users.vue